<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="1000"
    @click:outside="handleClose"
  >
    <v-card class="info-wrapper pa-0">
      <v-card-title class="pa-4 pl-11">
        <span :id="`history-details-title-${history.operation}`">{{ $t(`device.history.modal_details.title.${history.operation}`) }}</span>
        <v-icon id="history-details-close" @click="handleClose">mdi-close</v-icon>
      </v-card-title>
      <v-divider dark />
      <v-card-text class="info-content-wrapper pa-12 pt-5">
        <v-row>
          <v-col>
            <v-container class="container">
              <pre v-if="displayPayload.length > 2" id="history-details-payload">{{ displayPayload }}</pre>
              <pre v-else id="history-details-no-data">{{ $t('device.history.modal_details.no_data') }}</pre>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script lang="ts">

import { Component, Mixins, Prop } from 'vue-property-decorator';
import { HistoryInner } from 'ctp-history-service';
import Utils from '@/mixins/Utils';

@Component({})
export default class DevicesStatusUpdate extends Mixins(Utils) {
  @Prop()
  private enabled!: boolean;

  @Prop()
  private history!: HistoryInner;

  private get displayPayload(): string {
    if (this.history.payload) {
      const json = JSON.parse(this.history.payload);
      json.timestamp = this.formatDateTimeSecond(this.history.timestamp!);
      if (this.history.operation === 'event') {
        json.eventId = this.history.eventId;
      }
      switch (json.targetState) {
      case 0:
        json.targetState = 'active';
        break;
      case 1:
        json.targetState = 'lock';
        break;
      case 2:
        json.targetState = 'ban';
        break;
      case 3:
        json.targetState = 'transport';
        break;
      case 4:
        json.targetState = 'reboot';
        break;
      default:
        json.targetState = undefined;
      }
      return JSON.stringify(json, undefined, 4);
    }
    return '';
  }

  private get display() {
    return this.enabled;
  }

  private handleClose() {
    this.$emit('close', {});
  }
}

</script>
<style lang="scss" scoped>
@import './history-details.scss';
</style>
